import React from 'react'

import Navbar from '../components/Navbar'
import Investors from '../components/Investors'
import Footer from '../components/Footer'

const InvestorsPage = () => {
  return (
    <>
        <Navbar />
        <Investors />
        <Footer />
    </>
  )
}

export default InvestorsPage